import { styled } from 'styled-components'
import {
  colorCss,
  fontSizeCss,
  lineHeightCss,
  mobileColorCss,
  mobileFontSizeCss,
  mobileLineHeightCss,
} from 'common/utils/styleUtilsNew'

export interface BookingQuestionLabelProps {
  htmlFor: string
  color?: string
  mobileColor?: string
  fontSize?: number
  mobileFontSize?: number
  lineHeight?: number
  mobileLineHeight?: number
}

export const BookingQuestionLabel = styled.label<BookingQuestionLabelProps>`
  ${fontSizeCss}
  ${mobileFontSizeCss}
  ${colorCss}
  ${mobileColorCss}
  ${lineHeightCss}
  ${mobileLineHeightCss}
`
